import React, { useState, useRef, useContext } from 'react'
import { WorkspaceContext } from '../WorkspaceContext'
import './newfolder.scss'
import api from '../../../api'
import { useParams } from 'react-router-dom'
import useCloseOnClickAway from '../../../shared/hooks/UseCloseOnClickAway'
import { useDriveView } from '../DriveViewContext'
import { isNameTakenInDirectory, NAME_TAKEN_MESSAGE } from '../../../shared/utils/nameCollision'

const NewFolderPopup = () => {

    const ctx = useContext(WorkspaceContext);
    if (!ctx) throw new Error("Workspace must be wrapped in WorkspaceContext.Provider");
    const { setGlobalNewFolderPopup, uiMode, Folders, Snippets, Files } = ctx;
    const { folderId: driveFolderId } = useDriveView();
    const targetFolderParent = uiMode === 'files' ? driveFolderId : null;

    const nsCancelClick = () => {
        setGlobalNewFolderPopup(false);
    }

    const clientId = localStorage.getItem("flashroom_id")
    const { roomId } = useParams()


    const popupRef = useRef<HTMLDivElement | null>(null);

    useCloseOnClickAway({
        targetRef: popupRef,
        onClose: () => setGlobalNewFolderPopup(false),
    });







    const [folderName, setFolderName] = useState('');
    const [folderPermission, setFolderPermission] = useState<'restricted' | 'open'>('restricted');
    const [nameError, setNameError] = useState<string | null>(null);

    const canSubmit = true;

    const handleFolderNameChange = (value: string) => {
        setFolderName(value);
        setNameError(null);

        const trimmed = value.trim();
        if (!trimmed) {
            return;
        }

        const taken = isNameTakenInDirectory({
            folderParent: targetFolderParent,
            effectiveName: trimmed,
            folders: Folders,
            snippets: Snippets,
            files: Files,
        });

        setNameError(taken ? NAME_TAKEN_MESSAGE : null);
    };

    const createFolderClick = async () => {
        try {
            if (folderName.trim() === '') {
                setNameError('Folder name required');
                return;
            }

            if (isNameTakenInDirectory({
                folderParent: targetFolderParent,
                effectiveName: folderName.trim(),
                folders: Folders,
                snippets: Snippets,
                files: Files,
            })) {
                setNameError(NAME_TAKEN_MESSAGE);
                return;
            }

            await api.post(`/rooms/${roomId}/folder`, {
                fname: folderName,
                creatorId: clientId,
                folderPermission,
                folderParent: targetFolderParent,
            });

            setGlobalNewFolderPopup(false);
            setFolderName('');
            setFolderPermission('restricted');
            setNameError(null);
        } catch (error: any) {
            const message = error?.response?.data?.error || error?.response?.data?.message || 'Could not create folder. Please try again.';
            setNameError(message);
        }
    }

    const handleFolderKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key !== 'Enter' || !canSubmit) return;

        e.preventDefault();
        void createFolderClick();
    };





    return (
        <div ref={popupRef} className='new-snip fade-in'>

            <div className='ns-top'>
                <h3>New Folder</h3>

                <button className='ns-cancel' onClick={nsCancelClick}>
                    <svg className="x-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.01 111.01">
                        <g id="Layer_3" data-name="Layer 3">
                            <path
                                className="cls-1"
                                d="M232.21,289.66a10.1,10.1,0,0,1-14.31,0l-38.22-38.22-38.23,38.23a10.13,10.13,0,0,1-14.32-14.32l38.23-38.23L127.14,198.9a10.12,10.12,0,1,1,14.31-14.31l38.22,38.22,38.23-38.23a10.13,10.13,0,0,1,14.32,14.32L194,237.13l38.22,38.22A10.12,10.12,0,0,1,232.21,289.66Z"
                                transform="translate(-124.17 -181.62)"
                            />
                        </g>
                    </svg>
                </button>
            </div>

            <input maxLength={20} placeholder='folder name' type='text' onKeyDown={handleFolderKeyDown} onChange={(e) => handleFolderNameChange(e.target.value)} />
            {nameError && <span className="name-conflict-error">{nameError}</span>}

            <div style={{ marginTop: '18px' }}>
            </div>

            <div className='ns-bottom-f'>


                <select
                    className="co-select co-select-folder"
                    value={folderPermission}
                    onChange={(e) => setFolderPermission(e.target.value as 'restricted' | 'open')}
                >
                    <option value='restricted'>
                        Restricted
                    </option>

                    <option value='open'>
                        Open
                    </option>

                </select>
                <div className='quick-flex' style={{ marginLeft: 'auto' }}>
                    <button className='ns-cancel-b' onClick={nsCancelClick}>Cancel</button>
                    <button onClick={createFolderClick} disabled={!canSubmit} className={`ns-create ${!canSubmit ? 'ns-disabled' : ''}`}>Create</button>

                </div>
            </div>

        </div>
    )
}

export default NewFolderPopup
